/** Visible text for meta descriptions and JSON-LD. Tags and nbsp are not content. */
export function stripHtmlToText(value: string | null | undefined): string {
  return (value ?? '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
